export default __webpack_public_path__ + "static/media/IMG-20240708-WA0017.efc1dc4e.jpg";